module.exports = __webpack_public_path__ + "img/zoomout.c7c17fb3.svg";